import { Link } from "react-router-dom";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import Footer from "../../Footer";
import { useDispatch, useSelector } from "react-redux";
import { deleteApp } from "../../../redux/actions/AppActions";

const Apps = (props) => {
  let {
    id,
    name,
    logo,
    description,
    isAndriod,
    isIos,
    app_status,
    requestedBy,
  } = props.app;
  let from = props.from;
  let _organizationId = props?.organizationId;
  const organization = useSelector(
    (state) => state.organizationDetails.organization
  );
  const organizationRoles = organization?.user_role;
  const organizationId = organization?.organization_id;

  const role = useSelector((state) => state.userLogin.userInfo.data.role);
  let os;

  if (isAndriod === "1" && isIos === "1") {
    os = "Andriod, iOS";
  } else if (isAndriod === "1") {
    os = "Andriod";
  } else if (isIos === "1") {
    os = "iOS";
  }

  const dispatch = useDispatch();

  const deletehandler = (id) => {
    if (window.confirm("Are you sure want to delete app?")) {
      dispatch(deleteApp(id));
    }
  };

  return (
    <>
      <tr>
        {/* <div className="app-row"></div> */}
        <div className="name-logo">
        <td className="name1">{name}</td>
        <td className="logo1">
          <img alt="logo" src={logo} />{" "}
        </td>
        </div>
        
        <td className="app-description" >{description}</td>
        
        <td>
          <p className="mob">OS       : </p> {os}
        </td>

        {app_status === "Requested" && role === "Super_Admin" ? (
          <td>{requestedBy}</td>
        ) : from === "Apps" ? (
          <td>
            <p className="mob">Builds :</p>
            <Link to={`/app/${id}/builds`}>
              <i className="fa fa-cogs"></i>
            </Link>
          </td>
        ) : null}

        {role === "Super_Admin" && app_status !== "Requested" ? (
          <>
            <td>
              <p className="mob">Status :</p>
              <button className="badge-active">{app_status}</button>
            </td>
            <td>
              <Link to={`/organization/${_organizationId}/app/${id}/builds`}>
                <i className="fa fa-cogs"></i>
              </Link>
            </td>
          </>
        ) : null}

        {role !== "Super_Admin" &&
        organizationRoles === "Admin" &&
        app_status !== "Requested" ? (
          <>
            <td className="text-center">
              <p className="mob">Status :</p>
              <button className="badge-active">{app_status}</button>
            </td>
            <td className="text-center">
              <p className="mob">Action :</p>
              <Link to={`/app/edit/${id}`}>
                <i className="bi bi-pencil-square editICon"></i>
              </Link>
            </td>
          </>
        ) : null}

        {role !== "Super_Admin" &&
        organizationRoles === "Admin" &&
        app_status === "Requested" ? (
          <>
            <td> <p className="mob">Name :</p>{requestedBy}</td>
            <td>
              <p className="mob">Status :</p>
              <Link to={`/app/edit/${id}`}>
                <i className="bi bi-pencil-square editICon"></i>
              </Link>
            </td>
          </>
        ) : null}
      </tr>
    </>
  );
};

export default Apps;
